// i18n area 'auth' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.hu-HU.meta.json.
import type { enUS } from './auth'

export const huHU: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Jelentkezz be a fiókodba',
    username: 'Felhasználónév',
    usernamePlaceholder: 'Add meg a felhasználónevet',
    usernameHint: 'Címtár-realm elleni bejelentkezéshez használd a felhasználó@domain alakot',
    continue: 'Folytatás',
    changeUser: 'Nem te vagy?',
    password: 'Jelszó',
    forgotPassword: 'Elfelejtetted a jelszót?',
    submit: 'Bejelentkezés',
    otp: 'Egyszer használatos kód',
    otpSubtitle: 'Add meg a hitelesítő alkalmazás kódját',
    otpHint: 'Hat számjegy a hitelesítő alkalmazásból, vagy az egyik helyreállítási kódod',
    otpSubmit: 'Ellenőrzés',
    invalidCredentials: 'Érvénytelen felhasználónév vagy jelszó',
    tooManyAttempts: 'Túl sok próbálkozás — várj egy pillanatot, és próbáld újra',
    realmUnavailable: 'A realm jelenleg nem tudja ellenőrizni a hitelesítő adatokat — a klaszter store-ja nem érhető el. Jelentkezz be helyi felhasználóként (break-glass).',
    genericError: 'A bejelentkezés nem sikerült — elérhető a TVirt backend?'
  },
  user: {
    logout: 'Kijelentkezés',
    password: {
      menu: 'Jelszó módosítása',
      title: 'A jelszavad módosítása',
      current: 'Jelenlegi jelszó',
      new: 'Új jelszó',
      confirm: 'Új jelszó megerősítése',
      mismatch: 'A jelszavak nem egyeznek',
      error: 'A jelszót nem sikerült módosítani',
      forcedTitle: 'A folytatáshoz módosítsd a jelszavad',
      forcedHint: 'Ezt a jelszót egy adminisztrátor állította be, belépés előtt le kell cserélni.',
      forcedSubmit: 'Módosítás és belépés'
    },
    mfa: {
      title: 'Kétfaktoros hitelesítés',
      subtitle: 'Minden bejelentkezésnél kért második faktor',
      loadError: 'A második faktor állapota nem tölthető be',
      enrolled: 'Aktív',
      notEnrolled: 'Nem aktív',
      enrolledAt: 'Aktiválva',
      codesRemaining: 'Hátralévő helyreállítási kódok',
      requiredHint:
        'Egy adminisztrátor második faktort követel meg ezen a fiókon: állítsd be most — amíg nem teszed meg, bejelentkezni tudsz, de mást alig.',
      enroll: 'Beállítás',
      enrollTitle: 'Kétfaktoros hitelesítés beállítása',
      enrollHint: 'Olvasd be ezt a kódot a hitelesítő alkalmazással, majd a megerősítéshez írd be a kódot, amit mutat.',
      secretHint: 'Nem tudod beolvasni? Írd be ezt a titkot az alkalmazásba:',
      code: 'Kód az alkalmazásból',
      confirm: 'Megerősítés',
      startError: 'A beállítás nem indítható el',
      confirmError: 'A beállítás nem erősíthető meg',
      codesTitle: 'A helyreállítási kódjaid',
      codesWarning:
        'Ezek a kódok csak egyszer jelennek meg. Mentsd el őket most: mindegyikkel bejelentkezhetsz, ha a hitelesítő alkalmazás nem elérhető, és mindegyik csak egyszer használható.',
      codesAck: 'Elmentettem a helyreállítási kódokat',
      codesDone: 'Kész',
      copy: 'Másolás',
      copied: 'Másolva',
      download: 'Letöltés',
      regenerate: 'Új helyreállítási kódok',
      regenerateTitle: 'Helyreállítási kódok újragenerálása',
      regenerateHint: 'Az eddig kiadott összes kód abban a pillanatban érvényét veszti, amikor az új sorozat elkészül.',
      regenerateConfirm: 'Újragenerálás',
      regenerateError: 'A helyreállítási kódokat nem sikerült újragenerálni',
      remove: 'Eltávolítás',
      removeTitle: 'A második faktor eltávolítása',
      removeConfirm: 'Eltávolítás',
      removeHint: 'A fiók visszaáll csak jelszavasra. A második faktort bármikor újra beállíthatod.',
      removeRequiredHint:
        'Egy adminisztrátor második faktort követel meg ezen a fiókon, ezért a szerver megtagadja az eltávolítását — kérd meg előbb, hogy oldja fel a kötelezettséget.',
      removeError: 'A második faktort nem sikerült eltávolítani'
    },
    profile: {
      menu: 'Ugrás a profilomra',
      sessions: 'Aktív munkamenetek',
      sessionsHint: 'A nyitott munkameneteid ezen a csomóponton',
      sessionsEmpty: 'Nincs aktív munkamenet',
      sessionCreated: 'Bejelentkezve',
      sessionExpires: 'Lejár',
      revoke: 'Munkamenet visszavonása',
      revokeError: 'A munkamenetet nem sikerült visszavonni',
      loadError: 'A munkamenetek nem tölthetők be'
    }
  }
}
